import { Component } from '@angular/core';
import { IntersectionObserverDirective } from "../../../core/directives/animate-on-visible.directive";

@Component({
  selector: 'app-explore',
  imports: [IntersectionObserverDirective],
  templateUrl: './explore.html',
  styleUrl: './explore.scss',
})
export class Explore {

}
